import { nativeJSBridge, nativeJSBridgeSync } from './nativeJSBridge'
import { IBridgeOptions } from './interface'
import formatParams from './util/formatParams'

interface ISelfStock {
  /**
   * 股票代码,带有市场后缀
   *
   * @type {string}
   * @memberof ISelfStock
   * @example {'stockCode': '1A0001.SS'}
   */
  stockCode: string
}

interface ISelfStockResponse {
  success?: (result: ISelfStock) => void
  fail?: (result: ISelfStock) => void
  complete?: (result: ISelfStock) => void
}

/**
 * 获取自选股列表
 *
 * @param {IBridgeOptions<ISelfStockResponse>} { success, fail, complete }
 */
function getSelfStockSync({ success, fail, complete }: IBridgeOptions<ISelfStockResponse>) {
  const params = formatParams({
    funType: 'myStock',
    funName: 'getMyStock'
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params,
    success,
    fail,
    complete
  }
  try {
    nativeJSBridgeSync(opts)
  } catch (error) {
    console.log('getSelfStock error: ', error)
  }
}

/**
 * 获取自选股列表<br>
 * 一个异步接口，支持 Promise 化使用
 *
 * @returns {Promise<Array<ISelfStock>>}
 */
function getSelfStock(): Promise<Array<ISelfStock>> {
  const params = formatParams({
    funType: 'myStock',
    funName: 'getMyStock'
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params
  }

  return nativeJSBridge(opts)
}

export { getSelfStock, getSelfStockSync }
